var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0073 9.67969H22.0024C24.7375 9.67969 26.569 11.5999 26.569 14.4561V21.0486C26.569 23.8958 24.7375 25.8161 22.0024 25.8161H15.0073C12.2722 25.8161 10.4326 23.8958 10.4326 21.0486V14.4561C10.4326 11.5999 12.2722 9.67969 15.0073 9.67969ZM18.0413 20.1596L21.8736 16.3272C22.148 16.0529 22.148 15.6091 21.8736 15.3267C21.5993 15.0524 21.1475 15.0524 20.8732 15.3267L17.541 18.6589L16.1291 17.2469C15.8548 16.9726 15.403 16.9726 15.1286 17.2469C14.8543 17.5213 14.8543 17.965 15.1286 18.2474L17.0489 20.1596C17.186 20.2967 17.3635 20.3613 17.541 20.3613C17.7266 20.3613 17.9041 20.2967 18.0413 20.1596Z",
    fill: "#1BB600"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/media/icon-check-circle.2998cbc0a70b4fc9d140c26c7c191d0b.svg";
export { ForwardRef as ReactComponent };